export default __webpack_public_path__ + "f4b4c0fdcb8e966d2f7154742236d2e4.png";